import React from "react";
import { Link } from "react-router-dom";

export default function LeaderboardHeader({ selectedRace }) {
  const raceInfo = selectedRace?.raceInfo;
  const dashboardId = selectedRace?.legId?.replace(/^price_/, "");
  const numericDistance = Number(raceInfo?.distance);
  const distanceLabel = Number.isFinite(numericDistance)
    ? numericDistance.toLocaleString()
    : raceInfo?.distance;

  return (
    <header className="mb-5 px-1 sm:px-0" aria-labelledby="leaderboard-race-title">
      <div className="grid gap-4 md:grid-cols-[minmax(0,1fr)_300px] md:items-center md:gap-7">
        <div className="grid grid-cols-[60px,minmax(0,1fr)] items-center gap-3 sm:grid-cols-[64px,minmax(0,1fr)] sm:gap-4">
          <img
            src={raceInfo?.imageUrl}
            alt={`${raceInfo?.name} logo`}
            className="h-[60px] w-[60px] object-contain sm:h-16 sm:w-16"
          />

          <div className="min-w-0 text-left">
            <h1 id="leaderboard-race-title" className="m-0 !text-lg font-semibold leading-tight text-slate-900">
              {raceInfo?.name}
            </h1>
            <p className="mb-0 mt-1 text-sm font-medium leading-snug text-slate-700">
              {raceInfo?.legName} · {distanceLabel} km
            </p>
            <p className="mb-0 mt-1 text-xs leading-snug text-slate-500">
              {raceInfo?.userStartDate} – {raceInfo?.userEndDate}
            </p>
          </div>
        </div>

        <Link
          to={`/dashboard/${dashboardId}`}
          className="grid grid-cols-[36px,minmax(0,1fr),18px] items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-slate-900 no-underline transition hover:border-orange-300 hover:bg-orange-50 hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 md:w-[300px]"
          aria-label="Open Challenge dashboard to log or review activities"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-100 text-orange-700" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
              <rect x="14" y="14" width="7" height="7" rx="1" />
            </svg>
          </span>
          <span className="min-w-0">
            <strong className="block text-sm font-semibold leading-tight">Challenge dashboard</strong>
            <span className="mt-0.5 block text-xs leading-tight text-slate-500">Log or review activities</span>
          </span>
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-slate-400"
            aria-hidden="true"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </Link>
      </div>
    </header>
  );
}
